var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzleHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "puzzleHeart",
    transform: "translate(-949 -793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-heart_puzzle",
    transform: "translate(947 792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M62,22.214a18.078,18.078,0,0,1-2.3,8.332l-.055.109a30.1,30.1,0,0,1-1.527,2.6l-.014.014c-6.764,10.364-20.386,19.609-24.736,22.4-.873.545-1.364.845-1.364.845s-.491-.3-1.364-.859C26.3,52.868,12.718,43.6,5.941,33.273a29.873,29.873,0,0,1-1.623-2.727A18.19,18.19,0,0,1,2,22.214a16.383,16.383,0,0,1,28.636-10.7A15.382,15.382,0,0,1,32,13.255a15.382,15.382,0,0,1,1.364-1.745A16.383,16.383,0,0,1,62,22.214Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M34.509,18.158a5.475,5.475,0,0,1-5.5,5.449,5.15,5.15,0,0,1-1.376-.177V41.315H26.062l-.729-.654a2.7,2.7,0,0,0-1.83-.708,2.724,2.724,0,1,0,0,5.449,2.7,2.7,0,0,0,1.83-.708l.729-.654H27.63V54.16c-.88.545-1.376.845-1.376.845s-.5-.3-1.376-.858v-6.2a5.15,5.15,0,0,1-1.376.177,5.449,5.449,0,1,1,0-10.9,5.15,5.15,0,0,1,1.376.177V19.521h1.568l.729.654a2.7,2.7,0,0,0,1.83.708,2.724,2.724,0,1,0,0-5.449,2.7,2.7,0,0,0-1.83.708l-.729.654H24.879V10.04a15.388,15.388,0,0,1,1.376,1.744A15.387,15.387,0,0,1,27.63,10.04v2.847a5.15,5.15,0,0,1,1.376-.177A5.475,5.475,0,0,1,34.509,18.158Z",
    transform: "translate(5.745 1.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M59.036,25.879l-.055.11-1.526,2.628-.014.014H48.9a5.148,5.148,0,0,1,.177,1.376,5.451,5.451,0,1,1-10.9,0,5.148,5.148,0,0,1,.177-1.376H20.46V27.062l.654-.729a2.725,2.725,0,1,0-4.033,0l.654.729V28.63H5.322A30.2,30.2,0,0,1,3.7,25.879H13.824a5.148,5.148,0,0,1-.177-1.376,5.451,5.451,0,1,1,10.9,0,5.148,5.148,0,0,1-.177,1.376H42.262v1.568l-.654.729a2.725,2.725,0,1,0,4.033,0l-.654-.729V25.879Z",
    transform: "translate(0.639 4.652)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 60,
    height: 60,
    transform: "translate(949 793)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleHeart);
export default __webpack_public_path__ + "static/media/puzzleHeart.ff94c3a13441d6cc7e4f49f1444fc2fe.svg";
export { ForwardRef as ReactComponent };